import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, Button, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import Table from 'components/Table';
import { paginationParam, FILTER_TYPE } from 'shared/constant';

import NewFilter from 'components/NewFilter/NewFilter.container';
import { elipsis } from 'shared/utils/StringUtil';
import urlUtil from 'shared/utils/UrlUtil';
import { ORDER_STATUS } from '../../constant/DeliveryDefaultVar';
import { formatCSV } from '../../redux/actions/delivery';
import { getColorStatus } from '../../utils/FilesUtil';
import deliveryRoute from '../../route';
import text from './OrderList.page.translation';
import './OrderList.style.less';

export class OrderList extends Component {
  constructor(props) {
    super(props);

    const { resetFilter, match } = this.props;
    if (!match.params.page) {
      resetFilter();
    }
  }

  componentDidMount = () => {
    this.updateOrderListTable();
  };

  componentDidUpdate(prevProps) {
    const { formControlShow, match, filterValue } = this.props;

    if (prevProps.match.params.page !== match.params.page) {
      this.updateOrderListTable(filterValue);
    }

    if (prevProps.filterValue !== filterValue && !formControlShow) {
      if (
        !(
          prevProps.filterValue.length > 0 &&
          prevProps.filterValue.length > filterValue.length &&
          prevProps.filterValue[prevProps.filterValue.length - 1].inputValue
            .length === 0
        )
      ) {
        if (
          prevProps.match.params.page !== match.params.page ||
          (prevProps.match.params.page === match.params.page &&
            match.params.page > 1)
        ) {
          this.handleChangePage(1);
        } else {
          this.updateOrderListTable(filterValue);
        }
      }
    }
  }

  renderNoColumn = (pageNum, pageSize) => (_text, _record, index) => {
    const result = index + 1 + pageSize * (pageNum - 1);
    return result;
  };

  renderOrderId = record => {
    const getValue = get(record, 'delivery_id', '');
    if (getValue) {
      return (
        <button
          type="button"
          className="order-id"
          onClick={() => {
            this.handlerGoToDetail(record);
          }}
        >
          <Tooltip placement="topLeft" title={getValue}>
            <span>{elipsis(getValue, 30)}</span>
          </Tooltip>
        </button>
      );
    }
    return `-`;
  };
  handlerGoToDetail = record => {
    this.props.history.push(
      deliveryRoute.ORDER_DETAIL.replace(':id', record.delivery_id),
    );
  };

  renderStringValue = item => data => {
    const val = get(data, item, '');
    if (val) {
      return <span>{val}</span>;
    }
    return `-`;
  };

  renderTimeStamp = item => data => {
    const val = get(data, item, '');
    if (val) {
      const reformatTimestamp = moment(val).format('DD-MMM-YYYY, HH:mm');
      return `${reformatTimestamp} WIB`;
    }
    return `-`;
  };

  renderStatusColumn = (isCSV = false) => record => {
    const {
      intl: { formatMessage },
    } = this.props;
    const getStatus = get(record, 'current_delivery_status', '');

    let statusText = '-';
    let statusCSS = '';

    if (getStatus) {
      statusText = formatMessage({
        id: `orderStatus.${getStatus.toLowerCase()}`,
      });

      statusCSS = getColorStatus(getStatus);
    }

    if (isCSV) {
      return statusText;
    }

    return <span className={`status-col ${statusCSS}`}>{statusText}</span>;
  };

  handleChangePage = page => {
    urlUtil.changePageParams(
      deliveryRoute.ORDER_LIST,
      page,
      this.props.history,
    );
  };

  renderColumns = (pageNum, pageSize, formatMessage) => [
    {
      title: formatMessage(text.header.no),
      key: 'index',
      width: 80,
      render: this.renderNoColumn(pageNum, pageSize),
    },
    {
      title: formatMessage(text.header.orderId),
      key: 'delivery_id',
      width: 200,
      render: this.renderOrderId,
    },
    {
      title: formatMessage(text.header.source),
      key: 'client_name',
      width: 200,
      render: this.renderStringValue('client_name'),
    },
    {
      title: formatMessage(text.header.publicId),
      key: 'public_id',
      dataIndex: 'public_id',
      width: 200,
    },
    {
      title: formatMessage(text.header.acquirementId),
      key: 'dana_acquirement_id',
      dataIndex: 'dana_acquirement_id',
      width: 200,
    },
    {
      title: formatMessage(text.header.senderName),
      key: 'sender_name',
      width: 150,
      render: this.renderStringValue('sender_name'),
    },
    {
      title: formatMessage(text.header.phoneNumber),
      key: 'sender_phone',
      width: 150,
      render: this.renderStringValue('sender_phone'),
    },
    {
      title: formatMessage(text.header.courierBy),
      key: 'carrier_name',
      width: 150,
      render: this.renderStringValue('carrier_name'),
    },
    {
      title: formatMessage(text.header.partnerDeliveryId),
      key: 'partner_delivery_id',
      width: 200,
      render: this.renderStringValue('partner_delivery_id'),
    },
    {
      title: formatMessage(text.header.orderTime),
      key: 'order_placed_timestamp',
      width: 200,
      render: this.renderTimeStamp('order_placed_timestamp'),
    },
    {
      title: formatMessage(text.header.status),
      key: 'status',
      width: 150,
      render: this.renderStatusColumn(false),
    },
  ];

  getColumnsScrollX = columns => {
    const result = columns
      .map(x => x.width)
      .reduce((prev, next) => prev + next);
    return result;
  };

  getRowKey = record => record.delivery_id;

  renderTable = () => {
    const {
      intl: { formatMessage },
      orderListFilter,
      listOrder,
      loading,
    } = this.props;

    const pageSize = get(orderListFilter, 'page_size');
    const pageCount = get(orderListFilter, 'page_count');
    const pageNum = get(orderListFilter, 'page_num');
    const totalItem = pageSize * pageCount;

    const tableColumns = this.renderColumns(pageNum, pageSize, formatMessage);
    const scrollX = this.getColumnsScrollX(tableColumns);

    return (
      <Table
        bordered
        rowID={this.getRowKey}
        rowClass="striped-table"
        columns={tableColumns}
        dataSource={listOrder}
        pagination="true"
        currentPage={pageNum}
        totalItem={totalItem}
        loadingValue={loading}
        changePage={this.handleChangePage}
        scrollX={scrollX}
      />
    );
  };

  buildGetParamUrl = filterValue => {
    let result = '';

    filterValue.forEach(element => {
      const value = element.inputValue[0];
      switch (element.key) {
        case 'created_at':
          result += `&created_from=${value}&created_until=${
            element.inputValue[1]
          }`;
          break;
        default:
          result += `&${element.key}=${value}`;
          break;
      }
    });

    return result;
  };

  buildPaginationUrl = orderListFilter => {
    let result = '';
    result += `page_size=${encodeURIComponent(orderListFilter.page_size)}`;
    result += `&page_count=${encodeURIComponent(orderListFilter.page_count)}`;
    result += `&page_num=${encodeURIComponent(orderListFilter.page_num)}`;

    return result;
  };

  updateOrderListTable = () => {
    const {
      getListOrder,
      orderListFilter,
      filterValue,
      match,
      history,
    } = this.props;

    let paginationValue = { ...paginationParam };
    let paramUrl = '';
    const page = get(match, 'params.page', '');
    const pageInt = parseInt(page, 10) || '';

    if (filterValue.length > 0) {
      paramUrl = this.buildGetParamUrl(filterValue);
    }

    if (page) {
      if (pageInt && pageInt >= 1) {
        paginationValue = {
          ...orderListFilter,
          page_num: pageInt,
        };
        const paginationUrl = this.buildPaginationUrl(paginationValue);
        getListOrder(paginationUrl, paramUrl);
      } else {
        history.push(deliveryRoute.ORDER_LIST);
      }
    } else {
      const paginationUrl = this.buildPaginationUrl(paginationValue);
      getListOrder(paginationUrl, paramUrl);
    }
  };

  handleDownload = () => {
    const { filterValue, orderListFilter } = this.props;

    let paramUrl = '';
    if (filterValue.length) {
      paramUrl = this.buildGetParamUrl(filterValue);
    }

    const getPageSize = get(orderListFilter, 'page_size', 0);
    const getPageCount = get(orderListFilter, 'page_count', 0);
    const getSumRecord = parseInt(getPageSize, 10) * parseInt(getPageCount, 10);
    const paginationUrl = `page_size=${encodeURIComponent(getSumRecord)}`;

    this.props.getAllListOrder(
      paginationUrl,
      paramUrl,
      this.callbackCSVDownload(),
      this.callbackCSVDownload(true),
    );
  };

  callbackCSVDownload = isError => () => {
    if (!isError) {
      this.csvLink.link.click();
    }
  };
  refLink = r => {
    this.csvLink = r;
  };
  renderCSVFunction = () => {
    const {
      intl: { formatMessage },
      deliveryCSV,
    } = this.props;
    const headers = [
      { label: formatMessage(text.header.no), key: 'no' },
      { label: formatMessage(text.header.orderId), key: 'order_id' },
      { label: formatMessage(text.header.publicId), key: 'public_id' },
      {
        label: formatMessage(text.header.acquirementId),
        key: 'acquirement_id',
      },
      { label: formatMessage(text.header.senderName), key: 'sender_name' },
      { label: formatMessage(text.header.phoneNumber), key: 'phone_number' },
      { label: formatMessage(text.header.courierBy), key: 'carrier_name' },
      {
        label: formatMessage(text.header.partnerDeliveryId),
        key: 'partner_delivery_id',
      },
      { label: formatMessage(text.header.orderTime), key: 'order_timestamp' },
      { label: formatMessage(text.header.status), key: 'status' },
    ];
    return (
      <CSVLink
        data={formatCSV(
          get(deliveryCSV, 'payload', []),
          this.renderStatusColumn,
        )}
        filename={`ORDER_${moment().format('YYYY-MM-DDTHH:mm:ss')}.csv`}
        ref={this.refLink}
        headers={headers}
      ></CSVLink>
    );
  };

  renderDownloadButton = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Button
        type="primary"
        size="large"
        className="btn btn-download"
        onClick={this.handleDownload}
      >
        {formatMessage(text.btn.downloadCSV)}
      </Button>
    );
  };

  renderBreadCrumb = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">{formatMessage(text.home)}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{formatMessage(text.orderList)}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
    );
  };

  render() {
    const {
      intl: { formatMessage },
    } = this.props;

    const options = [
      {
        label: 'Order ID',
        value: 'ids',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: 'Source',
        value: 'client_name',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: 'Public ID',
        value: 'public_id',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: 'Acquirement ID',
        value: 'dana_acquirement_id',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: 'Phone Number',
        value: 'phone',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: 'Courier By',
        value: 'courier',
        type: FILTER_TYPE.RADIO,
        options: [
          {
            value: 'GO-SEND',
            label: 'GO-SEND',
          },
          {
            value: 'GRAB',
            label: 'GRAB',
          },
        ],
      },
      {
        label: 'Order Timestamp',
        value: 'created_at',
        type: FILTER_TYPE.RANGE_PICKER,
      },
      {
        label: 'Status',
        value: 'status',
        type: FILTER_TYPE.RADIO,
        options: [
          {
            value: ORDER_STATUS.INIT_TRANS,
            label: formatMessage(text.status.initTrans),
          },
          {
            value: ORDER_STATUS.PAY_ACQUIRED,
            label: formatMessage(text.status.payAcquired),
          },
          {
            value: ORDER_STATUS.DELIVERY_ORDER_CREATED,
            label: formatMessage(text.status.deliveryOrderCreated),
          },
          {
            value: ORDER_STATUS.REQUEST_FOR_PICKUP,
            label: formatMessage(text.status.requestForPickup),
          },
          {
            value: ORDER_STATUS.SEARCH_FOR_DRIVER,
            label: formatMessage(text.status.searchForDriver),
          },
          {
            value: ORDER_STATUS.DRIVER_ENROUTE,
            label: formatMessage(text.status.driverEnroute),
          },
          {
            value: ORDER_STATUS.CANCELLED_BY_USER,
            label: formatMessage(text.status.cancelledByUser),
          },
          {
            value: ORDER_STATUS.CANCELLED_BY_SYSTEM,
            label: formatMessage(text.status.cancelledBySystem),
          },
          {
            value: ORDER_STATUS.CANCELLED_BY_PARTNER,
            label: formatMessage(text.status.cancelledByPartner),
          },
          {
            value: ORDER_STATUS.PICKUP_REJECTED,
            label: formatMessage(text.status.pickupRejected),
          },
          {
            value: ORDER_STATUS.PICKUP_CANCELLED,
            label: formatMessage(text.status.pickupCancelled),
          },
          {
            value: ORDER_STATUS.PACKAGE_PICKED_UP,
            label: formatMessage(text.status.packagePickedUp),
          },
          {
            value: ORDER_STATUS.PACKAGE_IN_DELIVERY,
            label: formatMessage(text.status.packageInDelivery),
          },
          {
            value: ORDER_STATUS.PACKAGE_ARRIVED,
            label: formatMessage(text.status.packageArrived),
          },
          {
            value: ORDER_STATUS.DELIVERY_ORDER_RETURNED,
            label: formatMessage(text.status.deliveryOrderReturned),
          },
          {
            value: ORDER_STATUS.CANCEL_FAILED,
            label: formatMessage(text.status.cancelFailed),
          },
          {
            value: ORDER_STATUS.CANCEL_SUCCESS,
            label: formatMessage(text.status.cancelSuccess),
          },
          {
            value: ORDER_STATUS.PACKAGE_IN_TRANSIT,
            label: formatMessage(text.status.orderTransit),
          },
          {
            value: ORDER_STATUS.PACKAGE_IN_RETURN,
            label: formatMessage(text.status.orderReturn),
          },
          {
            value: ORDER_STATUS.ORDER_EXPIRED,
            label: formatMessage(text.status.orderExpired),
          },
        ],
      },
    ];

    return (
      <div className="main-content order-list-main-wrapper">
        {this.renderBreadCrumb()}

        <div className="white-box-wrapper">
          <span className="title">{formatMessage(text.orderList)}</span>

          <div className="download-btn-wrapper">
            {this.renderDownloadButton()}
            {this.renderCSVFunction()}
          </div>

          <NewFilter options={options} />

          {this.renderTable()}
        </div>
      </div>
    );
  }
}

OrderList.propTypes = {
  history: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  listOrder: PropTypes.array,
  orderListFilter: PropTypes.object,
  filterValue: PropTypes.array,
  getListOrder: PropTypes.func,
  getAllListOrder: PropTypes.func,
  resetFilter: PropTypes.func,
  formControlShow: PropTypes.bool,
  match: PropTypes.object,
  deliveryCSV: PropTypes.object,
};

export default OrderList;
